import { Pipe, PipeTransform } from '@angular/core';
import { TrackingProvider } from '../../providers/tracking';

@Pipe({
  name: 'match_event'
})
export class MatchEventPipe implements PipeTransform {

  constructor(
    private tracking: TrackingProvider
  ) {}

  transform(idEvent: string, idClient: string) {
    return this.tracking.findEntityById(idClient, idEvent, 'event');
  }
}


// WEBPACK FOOTER //
// ./src/pipes/event/match-event.ts